"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckCircle_1 = __importDefault(require("@material-ui/icons/CheckCircle"));
require("./SFSuccessDialogContent.css");
var SFSuccessDialogContent = function (_a) {
    var title = _a.title, message = _a.message;
    return (react_1.default.createElement("div", { className: "sf-success-dialog-content" },
        react_1.default.createElement("div", { className: "icon-container" },
            react_1.default.createElement(CheckCircle_1.default, null)),
        react_1.default.createElement("div", { className: "title" }, title ? title : 'Success!'),
        react_1.default.createElement("div", { className: "message" }, message)));
};
exports.default = SFSuccessDialogContent;
